module.exports = __webpack_public_path__ + "img/law3-m@2.6ec08830.webp";